module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2020/february-3b94350980c65d3cec3264ece6082999.png";